import { useIntl } from 'react-intl'
import _get from 'lodash/get';
import Notification from '@/shared/ui/Notification';
import { getSettingsLink } from '@/shared/constants/links';
import { useNavigation } from '@/processes/Router';
import { useMinerAccount } from '@/processes/MinerAccounts';

type WalletSetupProps = {
  className?: string;
}

const WalletSetup = (props: WalletSetupProps) => {
  const {
    className = '',
  } = props;
  const intl = useIntl();
  const { coin, navigate } = useNavigation();
  const { account, miner, isSupport } = useMinerAccount();
 
  const handleWalletSetup = (): void => {
    const settingsLink = getSettingsLink(coin, 'payout', {
      account,
      miner,
      support: isSupport ? 'true' : undefined,
    });
    
    navigate(settingsLink);
  };

  return (
    <div className={className}>
      <Notification
        text={intl.formatMessage({ id: 'wallet.setup.text' })}
        buttonText={intl.formatMessage({ id: 'wallet.setup.btn' })}
        buttonOnClick={handleWalletSetup}
      />
    </div>
  );
}

export default WalletSetup;
